import React from "react";
import {
  FaBolt,
  FaPaperPlane,
  FaClock,
  FaRandom,
  FaCodeBranch,
  FaRobot,
  FaGlobe,
  FaSync,
  FaCommentDots,
  FaComments,
  FaMicrophone,
  FaExchangeAlt,
  FaShopify,
  FaUsers,
  FaFileAlt,
} from "react-icons/fa";

const nodeTypes = [
  {
    type: "trigger",
    label: "Message Received",
    icon: FaBolt,
    color: "bg-brand",
    description: "Triggers when a message is received",
  },
  {
    type: "shopifyTrigger",
    label: "Shopify Event",
    icon: FaShopify,
    color: "bg-emerald-600",
    description: "Triggers when Shopify sends a signed order webhook",
  },
  {
    type: "sendMessage",
    label: "Send Message",
    icon: FaPaperPlane,
    color: "bg-blue-500",
    description: "Send a reply message",
  },
  {
    type: "delay",
    label: "Delay",
    icon: FaClock,
    color: "bg-amber-500",
    description: "Wait before next step",
  },
  {
    type: "jitter",
    label: "Jitter",
    icon: FaRandom,
    color: "bg-fuchsia-500",
    description: "Random delay within a range (mimic human cadence)",
  },
  {
    type: "condition",
    label: "Condition",
    icon: FaCodeBranch,
    color: "bg-purple-500",
    description: "Branch based on content",
  },
  {
    type: "triggerWebhook",
    label: "Trigger Webhook",
    icon: FaGlobe,
    color: "bg-red-500",
    description: "Send data to an external webhook URL",
  },
  {
    type: "waitForReply",
    label: "Wait for Reply",
    icon: FaCommentDots,
    color: "bg-orange-500",
    description: "Pause and branch on reply or timeout",
  },
  {
    type: "sendToAI",
    label: "Send to AI",
    icon: FaRobot,
    color: "bg-indigo-500",
    description: "Process message with OpenAI",
  },
  {
    type: "aiConversation",
    label: "AI Conversation",
    icon: FaComments,
    color: "bg-violet-500",
    description: "Persistent AI chat - auto-responds to every message",
  },
  {
    type: "aiAgent",
    label: "AI Agent",
    icon: FaRobot,
    color: "bg-fuchsia-500",
    description: "Fully AI-led: trained on your business, handles the chat, hands off to a human when needed",
  },
  {
    type: "aiAnalyzer",
    label: "AI Analyzer",
    icon: FaFileAlt,
    color: "bg-sky-600",
    description: "Read PDFs, documents, audio, and images the customer sends, then answer from them",
  },
  {
    type: "sendToGroup",
    label: "Group Follow-Up",
    icon: FaUsers,
    color: "bg-emerald-600",
    description: "Post a message into one or more WhatsApp groups",
  },
  {
    type: "loop",
    label: "Loop",
    icon: FaSync,
    color: "bg-teal-500",
    description: "Repeat message on schedule",
  },
  {
    type: "sendVoiceNote",
    label: "Voice Note",
    icon: FaMicrophone,
    color: "bg-pink-500",
    description: "Send AI-generated voice note via TTS",
  },
  {
    type: "httpRequest",
    label: "HTTP Request",
    icon: FaExchangeAlt,
    color: "bg-cyan-500",
    description: "Make external API request (GET/POST/PUT/PATCH/DELETE)",
  },
];

export default function NodePalette({ onAddNode }) {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2 overflow-x-auto">
        {nodeTypes.map((nt) => {
          const Icon = nt.icon;
          return (
            <div
              key={nt.type}
              className="flex items-center gap-2 px-3 py-2 rounded-lg border border-surface-border bg-surface-card cursor-grab hover:shadow-sm hover:border-brand/30 transition-all select-none"
              draggable
              onDragStart={(e) => onDragStart(e, nt.type)}
              onClick={() => onAddNode?.(nt.type)}
              title={nt.description}
            >
              <div
                className={`w-5 h-5 rounded-md ${nt.color} flex items-center justify-center`}
              >
                <Icon size={9} className="text-white" />
              </div>
              <span className="text-xs font-medium text-ink-primary">{nt.label}</span>
            </div>
          );
        })}
      </div>
      <p className="text-[10px] text-ink-faint mt-1 md:hidden">Tap to add a node</p>
      <p className="text-[10px] text-ink-faint mt-1 hidden md:block">Drag to canvas or click to add</p>
    </div>
  );
}
